export enum MimeTypesEnum {
    PDF = 'application/pdf',
    ZIP = 'application/zip',
    JPG = 'image/jpeg',
    PNG = 'image/png',
    WORD = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    EXCEL = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
}

export enum MimeTypesNames {
    PDF = 'PDF',
    ZIP = 'Zip'
}
